import * as React from 'react';
import * as ReactDOM from "react-dom";
import * as Tgcc from '../tgccGlobal'
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import * as Request from '../tgccRequest'
import {CSSProperties} from 'react'

import {NewCampusUploadFiles} from '../UploadFiles/NewCampusUploadFiles';

/* root for image */
declare var UploadRoot: string;
declare var AssetRoot: string;

var container : CSSProperties = {
    display:'flex',
    justifyContent:'center'
}

class ArtProps extends Tgcc.BaseProps{
    design: Tgcc.Design;
    uploads: any;
}
class StateType {
    proofId: string;
    uploadedFiles: any;
}
const endsWith = (str: string, suffix: string) => {
    return str.indexOf(suffix, str.length - suffix.length) != 1;
}

class _CatalogArtUpload extends React.Component<ArtProps, any>{

    state: StateType = new StateType();

    openDesign = () => {browserHistory.push(Tgcc.Routes.CampusSearch)};
       componentDidMount() {
         // copy existing uploads into local state
         this.setState({ uploadedFiles: this.props.uploads || [] });

         // ensure we have an ActiveProof in Redux
         if (!this.props.state.ActiveProof) {
           const newProof = new Tgcc.Proof();
           newProof.phone = this.props.state.UserInfo.phone;
           newProof.smsAllowed = this.props.state.UserInfo.smsAllowed;
           this.props.dispatch({
             type: Tgcc.StateAction.SetActiveProof,
             payload: newProof
           });
         }
       }
    handleUploadDesign = () => {
        this.props.dispatch({ type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.UploadDesign})
    }

    canDisplayFile = (name: string) => {
        if(!name)
            return false;
        var test = name.toUpperCase();
        return endsWith(test, '.JPG') || endsWith(test, '.PNG') || endsWith(test, '.TIF') || endsWith(test, '.SVG');
    }

    getImageSource = (fname: string, url: string) => {
        if(this.canDisplayFile(fname))
            return url;

        var test = fname.toUpperCase();
        if(endsWith(test,".PSD"))
            return Tgcc.Styles.uploadImagePlaceholder.PSD;
        if(endsWith(test, ".PDF"))
            return Tgcc.Styles.uploadImagePlaceholder.PDF;
        if(endsWith(test, ".AI"))
            return Tgcc.Styles.uploadImagePlaceholder.AI;
    }
    addUpload = (name: string, url: string) => {
        var oldFiles = this.state.uploadedFiles || {};
        var newFile = {}; newFile[name] = url;
        var newFiles = Object.assign({}, oldFiles, newFile);
        this.setState({uploadedFiles: newFiles});
        this.props.dispatch({type: Tgcc.StateAction.UpdateProof, payload: {uploadedFiles: newFiles}});
    }

    removeUpload = (fileUrl: string) => {
        var newFiles = {};
        Object.keys(this.state.uploadedFiles).map( (key) => {
            if(this.state.uploadedFiles[key] != fileUrl)
                newFiles[key] = this.state.uploadedFiles[key];
        });
        this.setState({uploadedFiles: newFiles});
        this.props.dispatch({type: Tgcc.StateAction.UpdateProof, payload: {uploadedFiles: newFiles}});
    }

    completeFileUpload = () => {
        this.props.dispatch({type: Tgcc.StateAction.SetEditState, payload: null});
    }

    setProofId = (id: string) => {
        this.props.dispatch({type: Tgcc.StateAction.UpdateProof, payload: {proofId: id}});
        this.setState({proofId: id});
    }

    getFileUpload(){
        return (
            <div>
                <NewCampusUploadFiles title="Upload Your Images/ Screenshots/ Artwork Files"
                    proofId={this.state.proofId} 
                    uploadedFiles={this.state.uploadedFiles}
                    addUpload={this.addUpload} 
                    removeUpload={this.removeUpload} 
                    setProofId={this.setProofId}
                    backAction={this.completeFileUpload}
                    state={this.props.state}
                    width="500px"
                    />
            </div>
        )
    }
    render(){  
        var fileUpload = this.getFileUpload();
        return (
        <div style={container}>
            {fileUpload}
        </div>
        )
    }
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { 
        design: state.ActiveProof.design,
        uploads: state.ActiveProof.uploadedFiles,
        state:state
    };
};
export var CatalogArtUpload = connect(mapStateToProps)(_CatalogArtUpload);
